export class User {
  email?: string;
  userid?: string;
  id?: number;
  last_name?: string;
  first_name?: string;
  locale?: string;
  domain?: string;
  user_role?: string;
  name?: string;
  val?: number;
  agerange?: number;
  alert?: boolean;
  cc?: boolean;
  gender?: number;
  news?: boolean;
  privacy?: boolean;
  nationality?: string;
  isenabled?: boolean;
  isfirstlogin?: boolean;
  uuid?: string;
  suid?: string;

  constructor() {
    this.locale = '';
    this.nationality = '';
    this.agerange = 0;
    this.gender = 3;
    this.news = false;
    this.cc = false;
    this.privacy = false;
    this.alert = false;
    this.isfirstlogin = true;
   }
}
